export const PL_SMS_EXPERIMENT_KEY = 'pl-sms-opt-in';
export const SMS_EXPERIMENT_MAP = {
  variation_1: 'variation_1',
  variation_2: 'variation_2',
  control: 'control',
};
export const VERSION_MAP = {
  [SMS_EXPERIMENT_MAP.control]: 'A',
  [SMS_EXPERIMENT_MAP.variation_1]: 'B',
  [SMS_EXPERIMENT_MAP.variation_2]: 'C',
};

export const DEFAULT_VERSION = 'A';
export const SMS = 'SMS';
export const OPT_IN = 'OPT_IN';
export const OPT_OUT = 'OPT_OUT';
export const APP_FLOW = 'APP_FLOW';

export const RESOURCE_TYPES = {
  ADD_VERBIAGE: 'ADD_VERBIAGE',
  TITLE: 'TITLE',
};
